/**
 * HOA pendant la soirée : de courtes phrases (« Awa vient d'arriver »,
 * « Plus que deux minutes de chat »). Réunion du 28 septembre : « messages
 * de Hoa type BD pop-up, pour informer de l'état de la salle ». Elles ne
 * demandent rien et s'effacent seules.
 *
 * Depuis le 1er octobre, elles passent dans la bulle de Hoa de l'étape en
 * cours, comme les annonces de la régie (messager.ts).
 */
import type { Expression } from "./Moai.js";
import { dire, retirer } from "./messager.js";

/** `dureeMs` : le temps où la phrase reste écrite, une fois tapée. */
export function direHoa(texte: string, dureeMs = 5000, expression: Expression = "surpris"): void {
  dire({ type: "hoa", texte, expression, tenir: dureeMs });
}

/** Se taire : la soirée est finie, ce qui passait n'a plus lieu d'être. */
export function taireHoa(): void {
  retirer("hoa");
}
